import { defineComponent as z, useTemplateRef as E, ref as d, provide as S, computed as T, watch as V, createElementBlock as y, openBlock as p, Fragment as N, createVNode as n, createElementVNode as w, unref as a, withCtx as o, normalizeClass as u, createBlock as A, resolveDynamicComponent as D, renderSlot as f, mergeProps as K, createCommentVNode as F } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Page/page.js";
import { t_global_breakpoint_xl as L } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/t_global_breakpoint_xl.js";
import { createReusableTemplate as R, useElementSize as W, useWindowSize as x } from "@vueuse/core";
import U from "../Drawer/Drawer.vue2.js";
import j from "../Drawer/DrawerContent.vue2.js";
import q from "../Drawer/DrawerPanelContent.vue2.js";
import G from "../Drawer/DrawerContentBody.vue2.js";
import { useOUIAProps as H } from "../../helpers/ouia.js";
import { getVerticalBreakpoint as J, getBreakpoint as Q } from "../../util.js";
const X = Symbol("PageManagedSidebarKey"), Y = Symbol("PageSidebarOpenKey"), me = /* @__PURE__ */ z({
  name: "PfPage",
  inheritAttrs: !1,
  __name: "Page",
  props: {
    role: {},
    mainContainerId: {},
    mainTabIndex: {},
    managedSidebar: { type: Boolean },
    tertiaryNavWidthLimited: { type: Boolean },
    notificationDrawerExpanded: { type: Boolean },
    defaultManagedSidebarOpen: { type: Boolean, default: !0 },
    mainAriaLabel: {},
    drawerExpanded: { type: Boolean },
    mainComponent: { default: "main" },
    contentFilled: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["page-resize"],
  setup(C, { expose: k, emit: h }) {
    const i = C, B = H({ id: i.ouiaId, safe: i.ouiaSafe }), P = h, [_, c] = R(), $ = E("page"), { width: s, height: m } = W($), t = d(!1), b = d(!1), g = d(!i.managedSidebar || i.defaultManagedSidebarOpen), I = d(i.managedSidebar);
    S(X, I);
    const r = T({
      get() {
        return t.value ? b.value : g.value;
      },
      set(e) {
        t.value ? b.value = e : g.value = e;
      }
    });
    S(Y, r);
    const { width: M } = x();
    V(M, (e) => {
      t.value = e < Number.parseInt(L.value, 10), P("page-resize", { mobileView: t.value, windowSize: e });
    }, { immediate: !0 });
    function O() {
      r.value = !r.value;
    }
    function v() {
      t.value && r.value && (r.value = !1);
    }
    return k({
      navToggle: O
    }), (e, Z) => (p(), y(N, null, [
      n(a(_), null, {
        default: o(() => [
          w("div", {
            class: u([a(l).pageMainContainer, { [a(l).modifiers.fill]: e.contentFilled }])
          }, [
            (p(), A(D(e.mainComponent), {
              id: e.mainContainerId,
              role: e.role,
              class: u(a(l).pageMain),
              tabindex: e.mainTabIndex,
              "aria-label": e.mainAriaLabel,
              onClick: v,
              onTouchstartPassive: v
            }, {
              default: o(() => [
                f(e.$slots, "default")
              ]),
              _: 3
            }, 40, ["id", "role", "class", "tabindex", "aria-label"]))
          ], 2)
        ]),
        _: 3
      }),
      w("div", K({ ref: "page" }, { ...a(B), ...e.$attrs }, {
        class: [a(l).page, {
          "pf-m-resize-observer": a(s) && a(m),
          [`pf-m-breakpoint-${a(Q)(a(s))}`]: a(s),
          [`pf-m-height-breakpoint-${a(J)(a(m))}`]: a(m)
        }]
      }), [
        f(e.$slots, "skeleton"),
        n(a(c)),
        e.$slots.drawer ? (p(), y("div", {
          key: 0,
          class: u(a(l).pageDrawer)
        }, [
          n(U, { expanded: e.drawerExpanded }, {
            default: o(() => [
              n(j, null, {
                content: o(() => [
                  n(q, null, {
                    default: o(() => [
                      f(e.$slots, "drawer")
                    ]),
                    _: 3
                  })
                ]),
                default: o(() => [
                  n(G, null, {
                    default: o(() => [
                      n(a(c))
                    ]),
                    _: 1
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["expanded"])
        ], 2)) : F("", !0)
      ], 16)
    ], 64));
  }
});
export {
  X as PageManagedSidebarKey,
  Y as PageSidebarOpenKey,
  me as default
};
